import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import DefaultView from "./views/DefaultView";
import PasswordLoginView from "./views/PasswordLoginView";
import CodeRequestView from "./views/CodeRequestView";
import CodeConfirmView from "./views/CodeConfirmView";
import MessageArea from "./MessageArea";

import { textLg } from "core/fontStyles";
import Link from "core/Link";
import BodyText from "core/BodyText";

import { useLoginFlow, LoginFlowProvider, VIEWS } from "./Context";

import { getConfig } from "frontend/store/config";

const Container = styled.div`
    ${Link} {
        display: inline;
        ${textLg};
    }

    ${BodyText} {
        ${textLg};
    }
`;

export const LoginUnwrapped = () => {
    const { view } = useLoginFlow();
    let content = null;

    if (view === VIEWS.DEFAULT) {
        content = <DefaultView />;
    }

    if (view === VIEWS.PASSWORD_LOGIN) {
        content = <PasswordLoginView />;
    }

    if (view === VIEWS.REQUEST_CODE) {
        content = <CodeRequestView />;
    }

    if (view === VIEWS.CONFIRM_CODE) {
        content = <CodeConfirmView />;
    }

    return (
        <Container>
            <MessageArea />
            <form>{content}</form>
        </Container>
    );
};

const Login = ({ afterAuth, goToPasswordReset }) => {
    const { accountLoginRequireCaptcha } = useSelector(getConfig);
    const requireCaptcha = !!accountLoginRequireCaptcha;

    return (
        <LoginFlowProvider
            afterAuth={afterAuth}
            requireCaptcha={requireCaptcha}
            goToPasswordReset={goToPasswordReset}
        >
            <LoginUnwrapped />
        </LoginFlowProvider>
    );
};

Login.propTypes = {
    afterAuth: PropTypes.func.isRequired,
    goToPasswordReset: PropTypes.func.isRequired
};

export default Login;
